import { createStore, compose, applyMiddleware, combineReducers, Reducer } from 'redux';
import { reducers } from '../reducers';
import { AppState } from '../models';
import { createEpicMiddleware, Epic } from 'redux-observable';
import 'semantic-ui-less/semantic.less';
import epics from '../epics';
import { AppAction, authRenewSuccess, authSuccess } from '../actions';
import { sessionStarted } from '../actions/session';
import { ajax } from 'rxjs/observable/dom/ajax';
import { analyticsMiddleware } from '../middleware/analyticsMiddleware';
import { createBrowserHistory } from 'history';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import { default as userManager } from '../utils/userManager';
import { User } from 'oidc-client';
import * as Raven from 'raven-js';
import { default as createRavenMiddleware } from 'raven-for-redux';
import * as uuid from 'uuid/v4';
import { initialize } from '../clients/mixpanelClient';

const releaseVersion = process.env.REACT_APP_RELEASE_VERSION || '';
const sessionId = uuid();

initialize(sessionId, releaseVersion);

export const history = createBrowserHistory();
const middleware = routerMiddleware(history);

const appConfig = require('appConfig');

if (appConfig.raven) {
  Raven.config(appConfig.raven.dsn, { release:  releaseVersion }).install();
}
const ravenMiddleware = createRavenMiddleware(Raven);
// tslint:disable-next-line:no-string-literal
const composeEnhancers = window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'] || compose;

const epicMiddleware = createEpicMiddleware((epics as Epic<AppAction, {}>),
                                            { dependencies: ajax });

const combinedReducer: Reducer<AppState> = combineReducers({
  ...reducers,
  routerState: routerReducer,
});

export const store = createStore<AppState>(combinedReducer, composeEnhancers(
  applyMiddleware(ravenMiddleware),
  applyMiddleware(epicMiddleware),
  applyMiddleware(analyticsMiddleware),
  applyMiddleware(middleware),
));

store.dispatch(sessionStarted(sessionId));

export const registerAuthRenew = () => {
  setTimeout(
    () => {
      userManager.events.addUserLoaded(() => {
        userManager.getUser()
        .then((renewedUser: User) => {
          store.dispatch(authRenewSuccess(
            renewedUser.profile.uid,
            renewedUser.access_token, 
            renewedUser.profile.idp, 
            renewedUser.profile.queues,
            renewedUser.profile.name,
          ));
        });
      });
    }, 
    30000);
};

export const initializeApp = async (): Promise<void> => {
  const user: User = await userManager.getUser();
  const isUserAlreadyAuthenticated = user && user.profile 
  && user.profile.uid && user.access_token;

  if (isUserAlreadyAuthenticated) {
    store.dispatch(
      authSuccess(user.profile.uid, 
                  user.access_token, 
                  user.profile.idp, 
                  user.profile.queues,
                  user.profile.name));
  }
  registerAuthRenew();
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/init.ts